import React from 'react'
import Modal from '../Modal'
import EquipamentoForm from './EquipamentoForm'
import { Equipamento } from '../../types'

interface EquipamentoModalProps {
  isOpen: boolean
  onClose: () => void
  equipamento?: Equipamento
  clienteId?: number
  onSuccess?: () => void
}

const EquipamentoModal: React.FC<EquipamentoModalProps> = ({
  isOpen,
  onClose,
  equipamento,
  clienteId,
  onSuccess
}) => {
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess()
    }
    onClose()
  }

  const handleCancel = () => {
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={equipamento ? 'Editar Equipamento' : 'Novo Equipamento'}
      size="xl"
    >
      <EquipamentoForm
        equipamento={equipamento}
        clienteId={clienteId}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Modal>
  )
}

export default EquipamentoModal
